export function openSafeLink(link, newOpen = false) {
  if (!link) return;

  try {
    const target = new URL(link, window.location.origin);
    if (!['http:', 'https:'].includes(target.protocol)) return;

    if (newOpen) {
      window.open(target.href, '_blank', 'noopener,noreferrer');
    } else {
      window.location.assign(target.href);
    }
  } catch (error) {
    // 잘못된 링크는 이동하지 않는다.
  }
}
